import { User } from "lucide-react";

export function AuthorBlock() {
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4 shadow-soft">
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
        <User className="h-5 w-5" />
      </div>
      <div>
        <p className="text-sm font-semibold text-foreground">
          Conteúdo revisado por Ismaque de Oliveira
        </p>
        <p className="text-xs text-muted-foreground">
          Fundador do MEI Toolbox · Atualizado em Junho de 2026
        </p>
      </div>
    </div>
  );
}
